import axios from "axios";
import ObjectUtil from "../../../../utils/common/ObjectUtil";
import {ordersServicesPath} from "../../../../Constants";

const issuingEdgesRestUrl = ordersServicesPath + '/organizations/issuing-edges'

export default class IssuingEdgeService {

    static async getAllByOrganizationNotClose() {
        return axios.get(issuingEdgesRestUrl + '/not-close');
    }

    static async getAllByOrganizationClose() {
        return axios.get(issuingEdgesRestUrl + '/close');
    }

    static async createByOrderIds(ids) {
        let data = ObjectUtil.createRequestObjectIds(ids);
        return await axios.post(issuingEdgesRestUrl + '/create-by-orders',
            JSON.stringify(data), {
                headers: {
                    'Content-Type': 'application/json'
                }
            });
    }

    static async issuanceEdgeRetailByReserve(id, materialWarehouseId, materialReserveId, issue) {
        return await axios.post(issuingEdgesRestUrl + '/' + id + '/issuance-edge-retail-by-reserve-id?materialWarehouseId=' + materialWarehouseId + '&materialReserveId=' + materialReserveId + '&issue=' + issue,
            [], {
                headers: {
                    'Content-Type': 'application/json'
                }
            });
    }

    static async deleteOrderByIds(id, ids) {
        let data = ObjectUtil.createRequestObjectIds(ids);
        return await axios.post(issuingEdgesRestUrl + '/' + id + '/delete-orders-by-ids',
            JSON.stringify(data), {
                headers: {
                    'Content-Type': 'application/json'
                }
            });
    }

    static async delete(id) {
        await axios.delete(issuingEdgesRestUrl + '/' + id);
    }

    static async close(id) {
        await axios.patch(issuingEdgesRestUrl + '/' + id + "/close");
    }

    static async open(id) {
        await axios.patch(issuingEdgesRestUrl + '/' + id + "/open");
    }

    static async setNumber(id, number) {
        await axios.patch(issuingEdgesRestUrl + '/' + id + "/set-number?number=" + number);
    }

    static async update(id) {
        await axios.patch(issuingEdgesRestUrl + '/' + id + "/update");
    }

    static async issuanceEdgeByIds(id, ids) {
        let data = ObjectUtil.createRequestObjectIds(ids);
        return await axios.post(issuingEdgesRestUrl + '/' + id + '/issuance-edge',
            JSON.stringify(data), {
                headers: {
                    'Content-Type': 'application/json'
                }
            });
    }

    static async issuanceEdgeRetail(materialWarehouseId, issue, id) {
        return await axios.post(issuingEdgesRestUrl + '/' + id + '/issuance-edge-retail' + "?materialWarehouseId=" + materialWarehouseId + "&issue=" + issue,
            [], {
                headers: {
                    'Content-Type': 'application/json'
                }
            });
    }
}